import { api } from '@/api/appGatewayServerApi'
import { isProduction } from '@/utils/env'
import store from '@/store'

type LogLevel = 'info' | 'warning' | 'error'

function getConsoleLogger(level: LogLevel) {
  /* eslint-disable no-console */
  if (level === 'error') return console.error
  if (level === 'warning') return console.warn
  return console.log
  /* eslint-enable no-console */
}

export async function sendLog(message: string, level: LogLevel = 'info') {
  const path = location.pathname
  const params = { message, level, path }

  // 本番以外では console にも出力する
  if (!isProduction()) getConsoleLogger(level)(params)

  if (store.getters['session/isLoggedIn']) {
    await api().web.log.write(params)
  }
}

export async function sendLogParams(
  message: string,
  params: object,
  level: LogLevel = 'info'
) {
  const json = JSON.stringify(params)
  await sendLog(`${message} params:${json}`, level)
}
